"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * As the shape of a dynamic object can not be known before it is manipulated,
 * this function attempts to detect the addition, updating, deletion of properties
 * on an object, after they have been actioned on the map's proxy (a living, mutable
 * object).
 *
 * This is a "just-in-time" operation, and a far less efficient way of proxying
 * changes than an "ahead-of-time" class-based approach.
 *
 * The value or `dynamicObject` has already been shallow cloned and in a
 * mutable state at this point.
 */
var duckPatchDynamicObject = function (proxyNode, dynamicObject, addProxyCallback, isClientSide) {
    if (isClientSide === void 0) { isClientSide = typeof window !== 'undefined'; }
    var proxy = proxyNode.proxy;
    // TODO: refactor to Object.keys, consider rename dynamicObject to value
    for (var key in dynamicObject) {
        if (proxy.hasOwnProperty(key))
            continue;
        // Key exists in value but not in proxy, therefore
        // has been deleted. Delete from value (while still in a
        // draft state), and delete child proxy.
        delete dynamicObject[key];
        delete proxyNode.children[key];
    }
    for (var key in proxy) {
        var addedValue = proxy[key];
        if (!proxy.hasOwnProperty(key) || // ignore proxy prototype keys
            (dynamicObject.hasOwnProperty(key) &&
                (dynamicObject[key] === addedValue ||
                    typeof addedValue === 'object')))
            continue;
        // Key exists in proxy but not in value, or exists in both with different primative values,
        // therefore has been added or edited. Copy ref of `addedValue` from proxy to value.
        dynamicObject[key] = addedValue;
        var isDomNode = isClientSide && addedValue instanceof Node;
        if (!addedValue ||
            Array.isArray(addedValue) ||
            typeof addedValue !== 'object' ||
            isDomNode)
            continue;
        // If new value is an object (and not an array or a DOM node), create a patch
        // to ensure it is frozen, and create a proxy at the key
        addProxyCallback(key, addedValue);
    }
};
exports.default = duckPatchDynamicObject;
//# sourceMappingURL=duckPatchDynamicObject.js.map